const ServiceIntroduction = [
  {
    path: '/service-introduction',
    redirect: '/service-introduction/home',
    meta: {
      title: '服务介绍',
      pageType: 'public'
    },
    children: [
      {
        path: 'home',
        name: 'ServiceIntroductionHome',
        component: () =>
          import('@/views/service-introduction/service-introduction'),
        meta: {
          layout: 'DefaultLayout',
          title: '服务介绍',
          pageType: 'public',
          cache: true,
          firstRouteName: 'serviceIntroduction'
        }
      },
      {
        path: 'bid-consultant',
        name: 'ServiceIntroductionBidConsultant',
        component: () => import('@/views/service-introduction/bid-consultant'),
        meta: {
          layout: 'DefaultLayout',
          title: '投标顾问',
          pageType: 'public',
          cache: true,
          firstRouteName: 'serviceIntroduction',
          icon: 'icon-fire-fill'
        }
      },
      {
        path: 'document-preview',
        name: 'ServiceIntroductionDocumentPreview',
        component: () =>
          import('@/views/service-introduction/document-preview'),
        meta: {
          layout: 'DefaultLayout',
          title: '标书预览',
          pageType: 'public',
          cache: true,
          firstRouteName: 'serviceIntroduction',
          icon: 'icon-fire-fill'
        }
      },
      {
        path: 'big-data-business',
        name: 'ServiceIntroductionBigDataBusiness',
        component: () =>
          import('@/views/service-introduction/big-data-business'),
        meta: {
          layout: 'DefaultLayout',
          title: '大数据商机',
          pageType: 'public',
          cache: true,
          firstRouteName: 'serviceIntroduction'
        }
      },
      {
        path: 'competitiveness',
        name: 'ServiceIntroductionCompetitiveness',
        component: () => import('@/views/service-introduction/competitiveness'),
        meta: {
          layout: 'DefaultLayout',
          title: '项目竞争力分析',
          pageType: 'public',
          cache: true,
          firstRouteName: 'serviceIntroduction'
        }
      },
      {
        path: 'bond',
        name: 'ServiceIntroductionBond',
        component: () => import('@/views/service-introduction/bond'),
        meta: {
          layout: 'DefaultLayout',
          title: '会员保证金担保',
          pageType: 'public',
          cache: true,
          firstRouteName: 'serviceIntroduction',
          icon: 'icon-NEW',
          iconStyle: 'font-size: 30px;'
        }
      }
    ]
  }
]

export default ServiceIntroduction
